export const getStands = (state) => state.stands